/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css } from "@panda/css";

export const styles = css({
	w: "full",
	smDown: {
		"& h3": {
			textStyle: "headingLG",
		},
	},
	"& .main-card-stack": {
		xlDown: {
			flexDirection: "column",
		},
	},
	"& .bullets": {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "eds.dimension.16",
		listStyleType: "disc",
		listStylePosition: "outside",
		paddingInlineStart: "eds.dimension.2",
		"& li": {
			marginInlineStart: "eds.dimension.8",
		},
		"& li::marker": {
			color: "eds.text.primary",
			fontSize: "eds.font.18",
		},
		"& strong": {
			color: "eds.text.primary",
			textStyle: "paragraphMD",
			"&:first-of-type": {
				textStyle: "headingSM",
			},
		},
	},
	"& .checklist": {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
		gap: "eds.dimension.16",
	},
	"& .button-list .ghost": {
		color: "eds.text.link.primary.default",
	},
});
